import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IGamesListModel} from "./lists/games-list-model.interface";

const POST_LOGIN_LISTS_ORDER_KEY = "cgp-post-login-lists-order";

interface IPostLoginListsOrder {
    lists: Record<string, string[]>;
}

export class ListsSortOrderStorage {
    constructor(private readonly services: IServiceFactoryExtended) {
    }

    private _createEmptyListsOrder(): IPostLoginListsOrder {
        return {
            lists: {}
        };
    }

    private _listsSavedOrder: IPostLoginListsOrder = null;
    private _getSavedListsOrder(): IPostLoginListsOrder {
        if(!this._listsSavedOrder) {
            this._listsSavedOrder = this.services.localStorage.getJson(POST_LOGIN_LISTS_ORDER_KEY) || this._createEmptyListsOrder();
        }
        return this._listsSavedOrder;
    }

    saveSortOrder(arenaName: string, lists: IGamesListModel[]): void {
        const listsOrder = this._getSavedListsOrder();
        listsOrder.lists[arenaName] = lists.map(list => list.title.translationKey);
        this.services.localStorage.setJson(POST_LOGIN_LISTS_ORDER_KEY, listsOrder);
    }

    sortLists(arenaName: string, lists: IGamesListModel[]): IGamesListModel[] {
        const arenaListsOrder = this._getSavedListsOrder().lists[arenaName] || [];
        if(arenaListsOrder.length === 0) {
            return lists;
        }

        const listsOrderMap = arenaListsOrder.reduce<Record<string, number>>((map, listTitle, index) => {
            map[listTitle] = index;
            return map;
        }, {});


        return lists.sort((l1, l2) => (listsOrderMap[l1.title.translationKey] || 0) - (listsOrderMap[l2.title.translationKey] || 0));

    }
}